export function chatBubble() {
    $(document).ready(function () {
        if ($('.growtype-chat-bubble').length > 0) {
            let bubbleDelay = $('.growtype-chat-bubble').attr('data-preview-delay') ? parseInt($('.growtype-chat-bubble').attr('data-preview-delay')) : 0;

            if (growtypeCookie.getCookie('growtype_chat_bubble_was_showed') === 'true') {
                bubbleDelay = 0;
            }

            if (growtypeCookie.getCookie('growtype_chat_bubble_is_closed') !== 'true') {

                // ⏳ Delay before showing the bubble
                setTimeout(() => {
                    $('.growtype-chat-bubble').fadeIn().promise().done(function () {
                        $(this).addClass('is-active');

                        if ($('.growtype-chat-bubble-inner-message').attr('show')) {
                            if (!$('.growtype-chat-bubble-inner-message').attr('data-show-once')) {
                                growtypeCookie.eraseCookie('growtype_chat_bubble_inner_message_was_showed');
                            }

                            if (growtypeCookie.getCookie('growtype_chat_bubble_inner_message_was_showed') !== 'true') {
                                $('.growtype-chat-bubble-inner-message').slideDown().promise().done(function () {

                                    setTimeout(function () {
                                        if ($('.growtype-chat-bubble-inner-message').attr('data-hide-after-show')) {
                                            $('.growtype-chat-bubble-inner-message').slideUp();

                                            if ($('.growtype-chat-bubble-inner-message').attr('data-show-once')) {
                                                growtypeCookie.setCookie('growtype_chat_bubble_inner_message_was_showed', true)
                                            }
                                        }
                                    }, 3500);
                                });
                            }
                        }

                        growtypeCookie.setCookie('growtype_chat_bubble_was_showed', true);
                    });
                }, bubbleDelay);

            } else {
                $('.growtype-chat-bubble').addClass('is-pasive');
            }

            // 🔄 Click Event Handlers
            $('.growtype-chat-bubble-inner').click(function () {
                window.location.href = $(this).attr('data-url');
            });

            $('.growtype-chat-bubble-close').on('click', function () {
                $('.growtype-chat-bubble').removeClass('is-active').addClass('is-closed');
                setTimeout(function () {
                    $('.growtype-chat-bubble').removeClass('is-closed').addClass('is-pasive');
                }, 1000);
                growtypeCookie.setCookie('growtype_chat_bubble_is_closed', true);
            });

            $('.growtype-chat-bubble-open').on('click', function () {
                $('.growtype-chat-bubble').removeClass('is-pasive').addClass('is-active');
                growtypeCookie.eraseCookie('growtype_chat_bubble_is_closed');
            });
        }
    });
}
